/**
 * @generated SignedSource<<35b0d1b8dda4ba883b598557010413d2>>
 * @relayHash b962bde817ae9133f076383673744639
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52b99b4d5da7ae41fc7cea0050d5a473435a64cac29f4d8502862f446fbffbc0

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateDateTimeFieldInput = {
  id: string;
  operation: JiraDateTimeFieldOperationInput;
};
export type JiraDateTimeFieldOperationInput = {
  datetime?: AGG$DateTime | null | undefined;
  operation: JiraSingleValueFieldOperations;
};
export type dateTime_issueFieldDateTime_DateTimeField_Mutation$variables = {
  input: JiraUpdateDateTimeFieldInput;
};
export type dateTime_issueFieldDateTime_DateTimeField_Mutation$data = {
  readonly jira: {
    readonly updateDateTimeField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly dateTime: AGG$DateTime | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type dateTime_issueFieldDateTime_DateTimeField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateDateTimeField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly dateTime: AGG$DateTime | null | undefined;
        readonly id: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type dateTime_issueFieldDateTime_DateTimeField_Mutation = {
  rawResponse: dateTime_issueFieldDateTime_DateTimeField_Mutation$rawResponse;
  response: dateTime_issueFieldDateTime_DateTimeField_Mutation$data;
  variables: dateTime_issueFieldDateTime_DateTimeField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "dateTime"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraDateTimeFieldPayload",
            "kind": "LinkedField",
            "name": "updateDateTimeField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraDateTimePickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraDateTimeFieldPayload",
            "kind": "LinkedField",
            "name": "updateDateTimeField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraDateTimePickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "52b99b4d5da7ae41fc7cea0050d5a473435a64cac29f4d8502862f446fbffbc0",
    "metadata": {},
    "name": "dateTime_issueFieldDateTime_DateTimeField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e0c0e1ca810b79fb98a05142a47ace9e";

export default node;
